/* Navigation only. Purchases and cart rendering belong to the installed apps. */
(() => {
  const productURL = window.MXProductURL;
  document.addEventListener('click', event => {
    const anchor=event.target.closest('[data-mx-product-anchor]');
    if(anchor){event.preventDefault();window.location.assign(productURL+'#'+anchor.dataset.mxProductAnchor);return;}
    const button=event.target.closest('[data-mx-product-link],[data-pv-ritual-upsell-cta]');
    if(button){event.preventDefault();window.location.assign(productURL);return;}
    // Additional purchase CTAs use the real product form, so app bundle quantities,
    // free gifts and line-item properties are never replaced with a single item.
    const extra=event.target.closest('[data-mx-add-to-cart]');
    if(extra && window.MXCommerceExternal){
      event.preventDefault();
      const form=document.querySelector('form[data-pv-atc-form]');
      const submit=form?.querySelector('button[type="submit"]');
      if(submit && !submit.disabled) submit.click();
      else window.location.assign(productURL);
    }
  });
})();
